var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileXlsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15255_19756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5014 0.28125H3.12012V23.7188H20.0561V5.75625L14.5014 0.28125Z",
    fill: "#E1F9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.501 0.28125L20.0557 5.75625H14.501V0.28125Z",
    fill: "#55A47E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3652 14.0059H1.94336V21.323H17.3652V14.0059Z",
    fill: "#55A47E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94336 21.3242L3.11992 22.318V21.3242H1.94336Z",
    fill: "#377753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48223 17.5465H5.49629L5.86191 16.6934H6.87441L6.03535 18.123L6.90254 19.5809H5.89004L5.50566 18.7043H5.4916L5.10723 19.5809H4.09473L4.96191 18.123L4.12285 16.6934H5.13066L5.48223 17.5465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47793 19.5805H7.57324V15.418H8.47793V19.5805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9148 18.7695C10.9148 18.6992 10.8726 18.6336 10.7929 18.5773C10.7133 18.5211 10.5633 18.4695 10.3523 18.4273C10.0148 18.3617 9.76169 18.2586 9.59294 18.1227C9.42419 17.9867 9.33513 17.7945 9.33513 17.5508C9.33513 17.2977 9.44295 17.082 9.65388 16.9039C9.86951 16.7258 10.1554 16.6367 10.5211 16.6367C10.9054 16.6367 11.2101 16.7211 11.4398 16.8945C11.6695 17.068 11.7773 17.2883 11.7633 17.5602L11.7586 17.5742H10.882C10.882 17.4617 10.8539 17.3727 10.7976 17.3164C10.7414 17.2555 10.6476 17.2273 10.5164 17.2273C10.4226 17.2273 10.3429 17.2555 10.2773 17.307C10.2117 17.3586 10.1836 17.4242 10.1836 17.5039C10.1836 17.5789 10.2211 17.6445 10.2961 17.7008C10.3711 17.7523 10.5211 17.8039 10.7414 17.8461C11.0976 17.9164 11.3554 18.0195 11.5242 18.1555C11.6929 18.2914 11.7773 18.4883 11.7773 18.7414C11.7773 18.9992 11.6601 19.2148 11.4304 19.3836C11.2008 19.5523 10.8961 19.6367 10.5164 19.6367C10.1226 19.6367 9.81326 19.5383 9.58357 19.3367C9.35388 19.1352 9.24607 18.9148 9.25545 18.6711L9.26013 18.657H10.0758C10.0804 18.793 10.1226 18.8914 10.1976 18.9523C10.2773 19.0133 10.3898 19.0414 10.5351 19.0414C10.657 19.0414 10.7461 19.018 10.8117 18.9711C10.8867 18.9242 10.9148 18.8586 10.9148 18.7695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7322 17.5465H13.7463L14.1119 16.6934H15.1244L14.2854 18.123L15.1525 19.5809H14.14L13.7557 18.7043H13.7416L13.3572 19.5809H12.3447L13.2119 18.123L12.3729 16.6934H13.3807L13.7322 17.5465Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15255_19756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileXlsx);
export default __webpack_public_path__ + "static/media/fileXlsx.ef86964adbb458cd7b38f8fcf33a4e5a.svg";
export { ForwardRef as ReactComponent };